var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSortAZDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 7.5C50 3.375 46.625 0 42.5 0H7.5C3.375 0 0 3.375 0 7.5V42.5C0 46.625 3.375 50 7.5 50H42.5C46.625 50 50 46.625 50 42.5V7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5924 8.3335H12.8057L8.43066 20.8335H10.9177L11.575 18.9556H15.7739L16.4217 20.8335H18.9049L14.5924 8.3335ZM12.3966 16.6081L13.6895 12.914L14.964 16.6081H12.3966Z",
    fill: "#EB2553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0463 29.167H8.36572V31.5144H15.5161L8.36572 39.8229V41.667H18.9289V39.3196H11.8959L18.8042 31.2923C18.9604 31.1109 19.0463 30.8794 19.0463 30.64V29.167Z",
    fill: "#EB2553"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4748 31.1568C41.1489 31.6383 41.305 32.5751 40.8235 33.2493L38.3492 36.7132C37.8677 37.3874 36.9309 37.5435 36.2568 37.062C35.5827 36.5805 35.4265 35.6436 35.908 34.9695L38.3823 31.5055C38.8638 30.8314 39.8006 30.6753 40.4748 31.1568ZM35.1646 40.2951C35.1646 40.9407 34.7515 41.5139 34.139 41.7181C33.5265 41.9223 32.852 41.7116 32.4646 41.1951L26.5264 33.2774C26.0293 32.6147 26.1636 31.6745 26.8264 31.1774C27.4891 30.6803 28.4293 30.8147 28.9264 31.4774L32.1646 35.7951L32.1646 10.1089C32.1646 9.28046 32.8362 8.60889 33.6646 8.60889C34.4931 8.60889 35.1646 9.28046 35.1646 10.1089L35.1646 40.2951Z",
    fill: "#EB2553"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortAZDark);
export default __webpack_public_path__ + "static/media/ic_sort_a_z_dark.1d16029bc7e3f59e648cb990315d94dc.svg";
export { ForwardRef as ReactComponent };